import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  textCurrency: {
    marginLeft: 8,
  },
  buttonsContainer: {
    marginTop: 24,
    marginBottom: 8,
  },
}));

export default useStyles;
